export default __webpack_public_path__ + "static/media/40546351.7e10ac50.jpg";